import React, { memo } from 'react';
import { Shape } from '../../types/Shape';
import HTMLShapeBase from './HTMLShapeBase';

interface HTMLAudioProps {
    shape: Shape;
    isSelected: boolean;
    showResizeHandles?: boolean;
    stagePos: { x: number; y: number };
    stageScale: number;
    isDrawing?: boolean;
    isEditing?: boolean;
    currentTool?: string;
    onDragStart?: (shapeId: string) => void;
    onDragMove?: (shapeId: string, newX: number, newY: number) => void;
    onDragEnd?: (shapeId: string) => void;
    onResize?: (shapeId: string, newWidth: number, newHeight: number, newX?: number, newY?: number) => void;
    onResizeEnd?: () => void;
    onClick?: (shapeId: string, e: React.MouseEvent) => void;
    onDoubleClick?: (shapeId: string, e: React.MouseEvent) => void;
    onContextMenu?: (shapeId: string, e: React.MouseEvent) => void;
    onMouseEnter?: (shapeId: string) => void;
    onMouseLeave?: () => void;
    onStageClick?: (canvasX: number, canvasY: number, e: React.MouseEvent) => void;
}

const HTMLAudio: React.FC<HTMLAudioProps> = (props) => {
    const { shape, stageScale } = props;

    return (
        <HTMLShapeBase {...props}>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f3f4f6',
                    borderRadius: '8px',
                    border: `1px solid ${shape.stroke || '#d1d5db'}`,
                    overflow: 'hidden',
                    pointerEvents: 'auto',
                }}
            >
                <audio
                    controls
                    src={shape.audioUrl}
                    style={{
                        width: '90%',
                        height: '40px',
                        outline: 'none',
                    }}
                    // prevent drag events on audio controls from propagating
                    onMouseDown={(e) => e.stopPropagation()}
                />
            </div>
        </HTMLShapeBase>
    );
};

export default memo(HTMLAudio);
